import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Chip, Container, Paper, Stack, Typography } from '@mui/material';
import { CompareArrows } from '@mui/icons-material';
import { CompareContext } from '../../context/compare.context';
import { MAX_COMPARE } from '../../utils/compare.utils';

// Barra fixa no rodapé dos resultados com os planos marcados para comparar.
const CompareTray = () => {
  const navigate = useNavigate();
  const { compareList, toggleCompare, clearCompare } = useContext(CompareContext);

  if (!compareList.length) return null;

  const canCompare = compareList.length >= 2;

  return (
    <Paper
      elevation={12}
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        borderTop: '3px solid',
        borderColor: 'primary.main',
        borderRadius: 0,
      }}
    >
      <Container sx={{ py: 1.5 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 1, md: 2 }}
          alignItems={{ xs: 'stretch', md: 'center' }}
        >
          <Stack direction="row" spacing={1} sx={{ flex: 1, flexWrap: 'wrap', rowGap: 1 }}>
            {compareList.map((plan) => (
              <Chip
                key={`${plan.insuranceCompany}-${plan.insuranceId}`}
                label={plan.insuranceName}
                onDelete={() => toggleCompare(plan)}
                sx={{ maxWidth: { xs: 150, md: 260 }, fontWeight: 600 }}
              />
            ))}
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', alignSelf: 'center', display: { xs: 'none', md: 'block' } }}
            >
              {canCompare
                ? `${compareList.length} de ${MAX_COMPARE} planos`
                : 'Escolha mais 1 plano para comparar'}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Button onClick={clearCompare} sx={{ color: 'text.secondary' }}>
              Limpar
            </Button>
            <Box sx={{ flex: 1 }} />
            <Button
              variant="contained"
              size="large"
              startIcon={<CompareArrows />}
              disabled={!canCompare}
              onClick={() => navigate('/comparar')}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {canCompare ? `Comparar ${compareList.length} planos` : 'Escolha mais 1'}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Paper>
  );
};

export default CompareTray;
